"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _merchButton = require("@site/pattern-library-core/merch-button");
/**
 * Local Imports
*/

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1x2qdib"
});
const IconContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconContainer",
  class: "pl-i1d9iz9i"
});
const TextContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextContainer",
  class: "pl-tqm6ywm"
});

/**
 * Renewal Banner Component
 *
 * @param {Object} props React props
 * @param {string} props.theme The theme for the banner.
 * @param {string} props.notification The notification message to be displayed in the banner.
 * @param {string} props.icon The icon to display in the banner. This should be a key that maps to an actual icon component.
 * @param {Array<Object>} props.ctas An array of cta objects.
 * @returns {React.ReactElement|null} `RenewalBanner` component or null if no notification is provided.
 * @public
 */
function RenewalBanner({
  theme,
  notification,
  icon,
  ctas
}) {
  if (!notification) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "renewal-banner-container",
    "data-theme": theme
  }, icon && /*#__PURE__*/_react.default.createElement(IconContainer, {
    "data-cy": "renewal-banner-icon"
  }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  })), /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement("p", {
    "data-cy": "renewal-banner-text"
  }, notification), ctas && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: ctas
  })));
}
var _default = exports.default = RenewalBanner;
RenewalBanner.propTypes = {
  theme: _propTypes.default.oneOf(['default', 'renewalState', 'renewalStateFilled', 'promotionState', 'promotionStateFilled']),
  notification: _propTypes.default.string,
  icon: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.object)
};